var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.101,
    height: 89.834,
    viewBox: "0 0 154.101 89.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d4e1f7;opacity:0.5;}.b{fill:#6fcadd;}.c{fill:#f9fbfc;}.d{fill:#d6dae7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5057.3 -8760.91)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5057.3 8760.91)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 25.598,
    cy: 25.598,
    rx: 25.598,
    ry: 25.598,
    transform: "translate(102.905 38.554)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 25.598,
    cy: 25.598,
    rx: 25.598,
    ry: 25.598,
    transform: "translate(96.183 8.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25.598,
    cy: 25.598,
    r: 25.598,
    transform: "translate(55.069 41.657) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 22.691,
    cy: 22.691,
    r: 22.691,
    transform: "translate(1.609 32.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 22.691,
    cy: 22.691,
    rx: 22.691,
    ry: 22.691,
    transform: "translate(0 71.868) rotate(-66.678)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.015,
    cy: 3.015,
    rx: 3.015,
    ry: 3.015,
    transform: "translate(98.123 8.317)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.015,
    cy: 2.015,
    rx: 2.015,
    ry: 2.015,
    transform: "translate(72.509 15.045)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.644,
    cy: 3.644,
    rx: 3.644,
    ry: 3.644,
    transform: "matrix(0.973, -0.229, 0.229, 0.973, 52.464, 12.291)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.863,
    cy: 1.863,
    rx: 1.863,
    ry: 1.863,
    transform: "translate(48.611 6.153)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.514,
    cy: 3.514,
    rx: 3.514,
    ry: 3.514,
    transform: "translate(97.839 78.379) rotate(-13.332)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.196,
    cy: 1.196,
    rx: 1.196,
    ry: 1.196,
    transform: "translate(74.767 77.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M206.485,430.386a2.514,2.514,0,1,0-2.514,2.514A2.514,2.514,0,0,0,206.485,430.386Z",
    transform: "translate(-154.525 -350.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M450.485,340.886a2.514,2.514,0,1,0-2.514,2.514A2.514,2.514,0,0,0,450.485,340.886Z",
    transform: "translate(-298.213 -297.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.79,342.037a2,2,0,1,0-2,2A2,2,0,0,0,107.79,342.037Z",
    transform: "translate(-97.009 -298.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.978,327.814a1.412,1.412,0,1,0-1.411,1.412A1.411,1.411,0,0,0,106.978,327.814Z",
    transform: "translate(-97.226 -290.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.659,355.733a1.174,1.174,0,1,0-1.174,1.174A1.174,1.174,0,0,0,102.659,355.733Z",
    transform: "translate(-94.963 -307.253)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 9.654,
    cy: 9.654,
    rx: 9.654,
    ry: 9.654,
    transform: "translate(77.291 65.946) rotate(-15.033)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5073.963 8779.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 125.079,
    height: 54.738,
    rx: 11.837,
    transform: "translate(125.079 54.738) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M304.792,285.512H225.027a12.541,12.541,0,0,0,12.54,12.541h72.581v-7.185A5.371,5.371,0,0,0,304.792,285.512Z",
    transform: "translate(-185.069 -285.512)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.7 25.456)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.688,342.117a1.7,1.7,0,0,1,1.21,1.644,1.722,1.722,0,0,1-3.444,0,2.628,2.628,0,0,1,.342-1.178l1.116-2.11a1.19,1.19,0,0,1,1.178-.713c.124,0,.093.4-.092,1.117Zm4.776,0a1.7,1.7,0,0,1,1.21,1.644,1.721,1.721,0,0,1-3.442,0,2.633,2.633,0,0,1,.341-1.178l1.117-2.11a1.192,1.192,0,0,1,1.179-.713c.124,0,.094.4-.093,1.117Z",
    transform: "translate(-168.454 -339.76)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.352 16.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.906,381.795c-.185-.714-.216-1.118-.092-1.118a1.19,1.19,0,0,1,1.178.714l1.116,2.11a2.626,2.626,0,0,1,.342,1.178,1.722,1.722,0,0,1-3.444,0,1.7,1.7,0,0,1,1.21-1.644Zm-4.776,0c-.187-.714-.217-1.118-.093-1.118a1.193,1.193,0,0,1,1.179.714l1.117,2.11a2.632,2.632,0,0,1,.341,1.178,1.721,1.721,0,0,1-3.442,0,1.7,1.7,0,0,1,1.21-1.644Z",
    transform: "translate(-364.231 -380.677)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.599 3.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.226,349.355H200.3a1.115,1.115,0,0,1-1.2-.99h0a1.115,1.115,0,0,1,1.2-.99h75.923a1.115,1.115,0,0,1,1.2.99h0A1.115,1.115,0,0,1,276.226,349.355Z",
    transform: "translate(-199.101 -347.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.226,361.451H200.3a1.115,1.115,0,0,1-1.2-.99h0a1.115,1.115,0,0,1,1.2-.99h75.923a1.115,1.115,0,0,1,1.2.99h0A1.115,1.115,0,0,1,276.226,361.451Z",
    transform: "translate(-199.101 -354.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.226,373.547H200.3a1.115,1.115,0,0,1-1.2-.99h0a1.115,1.115,0,0,1,1.2-.99h75.923a1.115,1.115,0,0,1,1.2.99h0A1.115,1.115,0,0,1,276.226,373.547Z",
    transform: "translate(-199.101 -361.622)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 78.328,
    height: 1.979,
    rx: 0.99,
    transform: "translate(0 14.919)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 6.71,
    cy: 6.71,
    rx: 6.71,
    ry: 6.71,
    transform: "translate(7.704 4.225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.25a7d5aba02749a0251af6344d844e61.svg";
export { ForwardRef as ReactComponent };